import React, { useContext, useEffect, useState } from 'react'
import { withRouter, useParams } from 'react-router-dom'
import { Page_settings } from '../../config/page_settings'
import strings from '../../lang/strings'
import { observer } from 'mobx-react'
import PageSubHeader from '../../components/common/page_sub_header'
import TableHeader from '../../components/control/table/table_header'
import TableCell from '../../components/control/table/table_cell'
import PerfectScrollbar from 'react-perfect-scrollbar'
import ReactPaginate from 'react-paginate'
import { customDateFormat, drawTableTitleCell, fphoto, string, formatNumber, getPointCellInfo } from '../../helper/common'
import { tbBjResultPageEditHeaders } from '../../config/constTable'
import { MaleUrl, PAGECOUNT } from '../../config/const'
import { rootStore } from '../../mobx/store'
import ConfirmButton from '../../components/control/button/confirm_button'
import { requestBjDataBuy } from '../../helper/business'
import { useHistory } from 'react-router-dom';
import BjResultBettingBoxComponent, { BjResultBettingBoxComponentBlur } from './table_bettingbox'


const BjResult = observer((props) => {
  const history = useHistory();
  const { dat_id } = props.location.state.result
  const context = useContext(Page_settings)
  const [result, setResult] = useState(null)
  let [dataList, setDataList] = useState([])
  let [pageCount, setPageCount] = useState(0)
  let [page, setPage] = useState(1)
  let [photo, setPhoto] = useState([])
  const [loaded, setLoaded] = useState(false);

  const [bettingData, setBettingData] = useState([]);

  useEffect(() => {
    if (dat_id == null) {
      history.goBack();
      return;
    }
    getResultData(dat_id);
    if (rootStore.getMe.mb_lv == 9) {
      window.history.replaceState(null, '', `/bj/bj_result/${dat_id}`); 
    }

  }, [dat_id])

  useEffect(() => {
    if (loaded) {
      getPhoto(result.dat_photo ?? '')
      getData(1)
      if (result.buy_is_betting == 1) {
        getBettingBoxTable();
      }
    }

  }, [result]);

  const getPhoto = (paths) => {
    context.post('data/get_data_photo', { dat_id: result.dat_id },
      response => {
        setPhoto(response.list)
      },
      false,
      err => {
        context.showAlert(err.msg)
      }
    )
    // if (rootStore.getMe.mb_id == result.mb_id) {
    //   let list = []
    //   if (paths !== '') {
    //     const arr = paths.split(',')
    //     for (let i = 0; i < arr.length; i++) {
    //       list.push(fphoto(arr[i], 'data'))
    //     }
    //   }
    //   setPhoto(list)
    //   return
    // }

  }

  const goDetail = (result) => {
    props.history.replace('/bj/bj_result', { result: result })
  }

  const onRegister = (data) => {
    props.history.push(data.dat_cate == 4 ? '/my_data/bj_new/0' : '/my_data/bj_new/1', { data: data })
  }

  const onDetail = (result) => {
    requestBjDataBuy(context, result, props, () => goDetail(result));
  }

  const onDelete = (info) => {
    if (info.other_purchased == 1) {
      return
    }
    context.showConfirm(strings.ask_delete, (val) => {
      if (!val) return
      context.post('data/data_delete', { dat_id: info.dat_id },
        () => {
          if (info.dat_id == result.dat_id) {
            props.history.goBack()
          }

          getData(1)
          getPhoto(result.dat_photo ?? '')
        },
        true,
        err => {
          setTimeout(() => { context.showAlert(err.msg) }, 500)
        }
      )
    })
  }

  const getResultData = (result_no) => {
    context.post('data/get_purchased_data', { dat_id: result_no },
      response => {
        setResult(response.data);
        setLoaded(true);
      },
      false,
      err => {
        context.showAlert(err.msg)
      }
    )
  }

  const getData = (page) => {
    const cate = result.dat_cate == 4 || result.dat_cate == 5 ? 45 : result.dat_cate;
    context.post('data/data_list', { mb_id: result.mb_id, cate: cate, page: page, count: PAGECOUNT },
      response => {
        let mb = rootStore.getMe
        mb.mb_point = response.mb_point
        rootStore.signIn(mb)
        setDataList(response.list)
        setPageCount(response.page_count)
      },
      false,
      err => {
        context.showAlert(err.msg)
      }
    )
  }

  const handlePageClick = (component) => {
    const nextPage = component.selected + 1
    setPage(nextPage)
    getData(nextPage)
  }

  const getBettingBoxTable = () => {
    context.post('data/game_list_new', { uid: result.dat_id }, response => {
      if (!response.data || response.data.length === 0) return;
      setBettingData(response.data.map(bet => ({
        price: bet.price,
        bae: bet.bae,
        kind: bet.kind,
        game: bet.game.map(item => ({
          ...item,
          home_dividend_rate : item.dg_home_rate ?? item.home_dividend_rate,
          no_odds : item.dg_no_odds_rate ?? item.no_odds,
          away_dividend_rate : item.dg_away_rate ?? item.away_dividend_rate,
          sel: item.dg_i_win == 1 ? 0 : item.dg_i_tie == 1 ? 1 : item.dg_i_loss == 1 ? 2 : -1,
          ans: item.hit_type ?? -1
        }))
      })));
    });
  };

  return (
    loaded &&
    <React.Fragment>
      <div className='im-container im-container-no-sidebar sm-ph-15'>
        <PageSubHeader pageName={''} pageMenu1={strings.main} pageMenu2={strings.bj} pageMenu={result.dat_cate == 4 ? strings.bj_pm_game : strings.bj_eve_game} />
        <div className='bj-result-area mt-30 sm-mt-0 sm-pb-20'>
          <div className={'w-100 text-right-center'}>
            {
              result.mb_id == rootStore.getMe.mb_id &&
              <ConfirmButton enabled={true} className={'btn-modify fs-14 f-sb mb-20'} onClick={() => { onRegister(result) }} text={strings.modify} />
            }
            {(result.mb_id == rootStore.getMe.mb_id && result.other_purchased == 0) &&
              <ConfirmButton enabled={true} className={'ml-20 btn-modify fs-14 f-sb mb-20'} onClick={() => { onDelete(result) }} text={strings.delete} />}
          </div>
          <div className='fs-28 sm-fs-18 f-b justify-content-center text-center word-keep ph-20 sm-ph-40'>{result.dat_title}</div>
          <div className='d-flex bj-result-profile mt-40 pb-16 sm-pb-12'>
            <div className='d-flex align-items-center flex-full'>
              <img className='bj-profile' src={fphoto(result.mb_photo, 'member', MaleUrl)} alt={''} />
              <div className='fs-18 sm-fs-16 f-sb ml-14 sm-ml-6 color-3a3335'>{result.mb_nick + ' ' + strings.bj}{result.mb_new == 1 && <img className='icon_new' src='/assets/image/new.png' alt='' />}</div>
            </div>
            <div>
              <div className='fs-14 sm-fs-12 color-aaaaaa'>등록일시 : {customDateFormat(result.dat_createdat)}</div>
              {result.dat_createdat != result.dat_updatedat && <div className='fs-14 sm-fs-12 color-aaaaaa'>수정일시 : {customDateFormat(result.dat_updatedat)}</div>}
            </div>
          </div>
          <div className='bj-note mt-20 fs-16 sm-fs-14' dangerouslySetInnerHTML={{ __html: result.dat_note }} />
          <div>
            {photo.map((item, index) => {
              return (
                <div className='bj-img mt-40 sm-mt-20 mr-20, sm-mr-10' key={index}>
                  <img className={'w-100 h-100'} src={item} />
                </div>
              )
            })
            }
          </div>
        </div>

        {result.buy_is_betting == 1 &&
          <>
            <div>
              {bettingData.map((bet, index) => (
                <BjResultBettingBoxComponent
                  key={index}
                  title={index === 0 ? strings.main_power : `${strings.sub_power} ${index}`}
                  dat_status={result.dat_status}
                  bettingDataList={bet.game}
                  expectRate={parseFloat(bet.bae)}
                  expectAmount={parseInt(bet.price)}
                  expectCoin={parseInt(bet.bae * bet.price)}
                  expectGainRate={parseInt(bet.bae * 100)}
                />
              ))}
            </div>
            <div className='color-e45a5a fs-16 sm-fs-14 text-right mt-8 f-b'>{strings.refund_msg}</div>
          </>

        }

        {result.buy_is_betting == 0 && result.dat_is_betting == 1 &&
          <div>
            <BjResultBettingBoxComponentBlur />

          </div>
        }

        <div className='fs-20 sm-fs-16 f-b mt-60 sm-mt-35 color-3a3335'>{strings.analyst_data}</div>
        <div className='shadow-div position-relative'>
          <PerfectScrollbar className='div_sale mt-20 sm-mt-14 mb-40'>
            <TableHeader className={'bg-white'} headers={tbBjResultPageEditHeaders} />
            {
              dataList.map((result, index) => {
                return (
                  <div key={index} className='tb-row clickable-row-highlight cursor-point'>
                    <TableCell
                      onClick={() => { onDetail(result) }}
                      value={(page - 1) * PAGECOUNT + index + 1}
                      className={tbBjResultPageEditHeaders[0].class}
                      center={tbBjResultPageEditHeaders[0].center}
                      child={null}
                    />
                    <TableCell
                      onClick={() => { onDetail(result) }}
                      value={customDateFormat(result.dat_start)}
                      className={tbBjResultPageEditHeaders[1].class}
                      center={tbBjResultPageEditHeaders[1].center}
                      child={null}
                    />
                    <TableCell
                      onClick={() => { onDetail(result) }}
                      value={result.dat_title}
                      className={tbBjResultPageEditHeaders[2].class}
                      center={tbBjResultPageEditHeaders[2].center}
                      child={drawTableTitleCell(result.dat_title, result.data_new)}
                    />
                    <TableCell
                      onClick={() => { onDetail(result) }}
                      value={result.mb_nick}
                      className={tbBjResultPageEditHeaders[3].class}
                      center={tbBjResultPageEditHeaders[3].center}
                      child={null}
                    />
                    <TableCell
                      onClick={() => onDetail(result)}
                      value={customDateFormat(result.dat_updatedat)}
                      className={tbBjResultPageEditHeaders[4].class}
                      center={tbBjResultPageEditHeaders[4].center}
                      child={null}
                    />
                    <TableCell
                      onClick={() => { onDetail(result) }}
                      value={getPointCellInfo(result).value}
                      color={getPointCellInfo(result).color}
                      className={tbBjResultPageEditHeaders[5].class}
                      center={tbBjResultPageEditHeaders[5].center}
                      child={null}
                    />
                    {result.mb_id == rootStore.getMe.mb_id ?
                      <TableCell
                        value={''}
                        className={tbBjResultPageEditHeaders[6].class}
                        center={tbBjResultPageEditHeaders[6].center}
                        child={
                          <div className={'d-center w-100 h-100'}>
                            <ConfirmButton
                              className={result.other_purchased === 1 ? 'bd-0 item-data-button-disabled w-100 fs-14 f-m' : 'bd-0 item-data-button w-100 fs-14 f-m'}
                              onClick={() => { onDelete(result); }}
                              text={strings.delete}
                            />
                          </div>
                        }
                      />
                      :
                      <></>
                    }

                  </div>
                )
              })
            }
          </PerfectScrollbar>
        </div>
        {pageCount > 1 &&
          <ReactPaginate
            previousLabel={''}
            nextLabel={''}
            breakLabel={'...'}
            breakClassName={'break-me'}
            pageCount={pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={handlePageClick}
            containerClassName={'pagination'}
            subContainerClassName={'pages pagination'}
            activeClassName={'active'}
          />
        }
      </div>
    </React.Fragment>
  )
})

export default withRouter(BjResult)
